const REMOVE_NON_SERIES_CARD = 'publishers/REMOVE_NON_SERIES_CARD';
const SET_NON_SERIES_CARDS = 'publishers/SET_NON_SERIES_CARDS';
const REMOVE_CHAPTER_CARD = 'publishers/REMOVE_CHAPTER_CARD';
const SET_CHAPTER_CARDS = 'publishers/SET_CHAPTER_CARDS';
const REMOVE_SERIES = 'publishers/REMOVE_SERIES';
const SET_CHAPTERS = 'publishers/SET_CHAPTERS';
const SET_SERIES = 'publishers/SET_SERIES';
const REQUEST_VIDEO_COURSE_CARD = 'publishers/REQUEST_VIDEO_COURSE_CARD';
const SET_VIDEO_COURSE_CARD = 'publishers/SET_VIDEO_COURSE_CARD';
const FETCH_VIDEO_COURSE_CARDS = 'publishers/SET_VIDEO_COURSE_CARDS';
const UPDATE_VIDEO_COURSE_CARD = 'publishers/UPDATE_VIDEO_COURSE_CARD';

export default {
  REMOVE_NON_SERIES_CARD,
  SET_NON_SERIES_CARDS,
  REMOVE_CHAPTER_CARD,
  SET_CHAPTER_CARDS,
  REMOVE_SERIES,
  SET_CHAPTERS,
  SET_SERIES,
  SET_VIDEO_COURSE_CARD,
  REQUEST_VIDEO_COURSE_CARD,
  FETCH_VIDEO_COURSE_CARDS,
  UPDATE_VIDEO_COURSE_CARD,
};



// WEBPACK FOOTER //
// ./src/app/publishers/store/mutation-types.js